import { render, staticRenderFns } from "./addClassDialog.vue?vue&type=template&id=2ffefaf5&scoped=true&"
import script from "./addClassDialog.vue?vue&type=script&lang=js&"
export * from "./addClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./addClassDialog.vue?vue&type=style&index=0&id=2ffefaf5&lang=less&scoped=true&"
import style1 from "./addClassDialog.vue?vue&type=style&index=1&id=2ffefaf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffefaf5",
  null
  
)

export default component.exports